function Comment({children}) {
    return <button className='interaction'><i class="fa-regular fa-comment"></i>{children}</button>;
  }
  export default Comment;